import React from 'react';
import { useCryptoWallets } from '../../hooks/useCryptoWallets';
import { WalletCard } from './WalletCard';

export const WalletDashboard: React.FC = () => {
  const { wallets } = useCryptoWallets();

  return (
    <div className="row g-5 mb-5 align-items-stretch">
      {/* Column 1 - Ethereum & Solana (Stacked) */}
      <div className="col-12 col-xl-4 d-flex flex-column gap-5">
        {wallets.filter(w => w.config.id === 'evm' || w.config.id === 'sol').map(({ config, query }) => (
          <div key={config.id} className="flex-grow-1">
            <WalletCard config={config} query={query} />
          </div>
        ))}
      </div>
      
      {/* Column 2 - Bitcoin & XRP (Stacked) */}
      <div className="col-12 col-xl-4 d-flex flex-column gap-5">
        {wallets.filter(w => w.config.id === 'btc' || w.config.id === 'xrp').map(({ config, query }) => (
          <div key={config.id} className="flex-grow-1">
            <WalletCard config={config} query={query} />
          </div>
        ))}
      </div>

      {/* Column 3 - Polygon (Stretched / Stacked fallback) */}
      <div className="col-12 col-xl-4 d-flex flex-column gap-5">
        {wallets.filter(w => w.config.id === 'polygon').map(({ config, query }) => (
          <div key={config.id} className="flex-grow-1 h-100">
            <WalletCard config={config} query={query} />
          </div>
        ))}
      </div>
    </div>
  );
};
